const normaliseToArray = <T>(input: T | T[] | undefined | null): T[] => {
  if (!input) return [];
  return Array.isArray(input) ? input : [input];
};

export default normaliseToArray;